module.exports = __webpack_public_path__ + "GooglePixel3-Black@2x.png?24e24b9013fdd0bd3231e4c5f0e9aff0";